export default __webpack_public_path__ + "static/media/get-started-step-4.322aae7a.png";